import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AssetSupplyOrderMoveableAssetResponseInterface } from 'features/AssetManagement/@types/typeSupplyOrder'
import {
  AssetItemType,
  GenerateAssetIdInitStateType,
} from 'features/SupplyOrder/@types/GenerateAssetId'

const initialState: GenerateAssetIdInitStateType = {
  isLoading: true,
  queryParams: {
    pageSize: 20,
    pageIndex: 1,
    assetCode: '',
  },
  listData: [],
  modalRegisterAsset: {
    isOpen: false,
  },
  modalUnassignConfirmation: {
    isOpen: false,
    locationId: 0,
    assets: [],
  },
  selectedAsset: [],
  supplyOrderMovableAssets: [],
}

const generateAssetIdSlice = createSlice({
  name: 'generateAsset',
  initialState,
  reducers: {
    setIsLoading: (state, action) => {
      state.isLoading = action.payload
    },
    setQueryParams: (state, action) => {
      state.queryParams = {
        ...state.queryParams,
        ...action.payload,
      }
    },
    setListData: (state, action) => {
      state.listData = action.payload
    },
    setModalRegisterAsset: (state, action) => {
      state.modalRegisterAsset = {
        ...state.modalRegisterAsset,
        ...action.payload,
      }
    },
    setModalUnassignConfirmation: (
      state,
      action: PayloadAction<GenerateAssetIdInitStateType['modalUnassignConfirmation']>,
    ) => {
      state.modalUnassignConfirmation = action.payload
    },
    resetModalRegisterAsset: (state) => {
      state.modalRegisterAsset = initialState.modalRegisterAsset
    },
    resetModalUnassignConfirmation: (state) => {
      state.modalUnassignConfirmation = initialState.modalUnassignConfirmation
    },
    setSelectedAsset: (state, action: PayloadAction<AssetItemType[]>) => {
      state.selectedAsset = action.payload
    },
    setSupplyOrderMovableAssets: (
      state,
      action: PayloadAction<AssetSupplyOrderMoveableAssetResponseInterface['data']>,
    ) => {
      state.supplyOrderMovableAssets = action.payload
    },
  },
})

export const {
  setIsLoading,
  setQueryParams,
  setListData,
  setModalRegisterAsset,
  setModalUnassignConfirmation,
  resetModalRegisterAsset,
  resetModalUnassignConfirmation,
  setSelectedAsset,
  setSupplyOrderMovableAssets,
} = generateAssetIdSlice.actions
export default generateAssetIdSlice.reducer
